<template>
    <div id="select-JBrowse">
        <div class="JBrowse-description">
            <a><b>Available Datasets</b></a>
            <button @click="searchGeneInformation" title="Click to view references" style="margin-left: 520px;background: #7BAE82">
                <u>Articles corresponding to the genome version</u>
            </button>
        </div>
        <ul v-for="information in information_dict" :key="information" style="margin-left: 50px;list-style-type:none">
            <template v-if="information.species != 'All'">
                <li style="margin: 10px 0px">
                    <a @click="toJBrowse(information.species)" title="Click to browse JBrowse">
                        <button class="JBrowse_button">
                            {{information.species}}: <i>{{information.introduction}}</i>
                        </button>
                    </a>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: "JBrowse",
        data() {
            return {
                information_dict: []
            }
        },
        mounted() {
            this.judgeStyle();
            this.show_information()
        },
        methods:{
            judgeStyle() {
                document.getElementsByTagName('html')[0].style.height = '';
                document.getElementsByTagName('body')[0].style.height = '';
            },
            show_information() {
                axios({
                    url: 'http://39.100.233.196:8001/api/get-species-information/',
                    type: 'json',
                    method: 'get',
                }).then((res)=>{
                    // this.information_dict = res.data
                    this.information_dict = []
                    var sortKeys = Object.keys(res.data).sort((a, b)=>{
                        return res.data[a].introduction > res.data[b].introduction
                    })

                    for (var sortIndex in sortKeys) {
                        this.information_dict.push(res.data[sortKeys[sortIndex]])
                    }

                    // console.log(res.data)
                    // console.log(this.information_dict)
                })
            },
            toJBrowse(species) {
                this.$router.push({path: '../SearchJBrowse/', query: {Genome: species}})
            },
            searchGeneInformation () {
                let routeUrl = this.$router.resolve({
                    path: '../SpeciesInfo/'
                });
                window.open(routeUrl.href)
            },
        },
    }
</script>

<style>

    #select-JBrowse {
        margin: 30px auto;
        /*border: solid 1px #000000;*/
        width: 1100px;
    }

    #select-JBrowse .JBrowse-description {
        margin: 20px auto 20px 0px;
        width: 1000px;
        color: #30336b;
        text-align: left;
        font-size: 25px;
    }

    #select-JBrowse .JBrowse_button {
        background: #E8F2EC;
        border: none;
        color: #275015;
        font-size: 16px;
    }

    #select-JBrowse .JBrowse_button:hover {
        color: red;
    }

</style>